import { Omit } from 'utils/happyTypes';
import { ITaskNotificationProperties } from 'store/tasks/tasksType';
import i18n from '../../../../i18n';

export default {
  user: 'کاربر',
  assignee: 'مجری',
  taskType: 'نوع کار',
  progress: 'میزان پیشرفت',
  alarmProgress: 'پیام پیشرفت کار یک فرد به دیگر همکاران ارسال شود',
  assigneesList: 'لیست مجری‌ها',
  progressStatus: 'وضعیت اجرا',
  startDateWithTime: 'زمان شروع به همراه ساعت',
  startDateWithoutTime: 'زمان شروع بدون ساعت',
  dueDateWithTime: 'مهلت انجام به همراه ساعت',
  dueDateWithoutTime: 'مهلت انجام بدون ساعت',
  notificationsSetting: 'پیکربندی اطلاع‌رسانی‌ها',
  sendSMS: 'ارسال پیامک',
  notifyPastEvents: 'ارسال اعلان برای رخدادهای گذشته',
  sendTo: 'ارسال پیام به',
  verifier: 'تایید کننده',
  follower: 'دنبال کننده',
  publisher: 'منتشرکننده',
  subtaskPublisher: 'منتشرکننده زیروظیفه',
  question: 'فیلد:',
  whichOptions: 'پاسخ فیلد:',
  messagePattern: ' پیام ارسالی',
  notifyWithSMS: 'اعلان به صورت پیامک',
  notifyUsersBaseOnSelectedQuestion:
    'ارسال اعلان به کاربر بر اساس گزینه انتخاب شده در فیلدها',
  startDate: 'زمان شروع',
  dueDate: 'مهلت انجام',
  disableSendingNotification: 'غیرفعالسازی این پیامک ارسالی',
};

export const notificationTitles: {
  [key in keyof Omit<
    ITaskNotificationProperties,
    'alarmProgress' | 'notifyWithSMS' | 'fieldNotifications'
  >]: string;
} = {
  assignmentMessageAll: i18n.t('assignmentMessageAll', {
    ns: 'companyManagement',
  }),
  assignmentMessageSelf: i18n.t('assignmentMessageSelf', {
    ns: 'companyManagement',
  }),
  verifierMessageSelf: i18n.t('verifierMessageSelf', {
    ns: 'companyManagement',
  }),
  assignmentMessageProgressDoes: i18n.t('assignmentMessageProgressDoes', {
    ns: 'companyManagement',
  }),
  assignmentMessageProgressVerifier: i18n.t(
    'assignmentMessageProgressVerifier',
    { ns: 'companyManagement' }
  ),
  assignmentMessageProgressDoesByOther: i18n.t(
    'assignmentMessageProgressDoesByOther',
    { ns: 'companyManagement' }
  ),
  assignmentMessageProgressVerifierByOther: i18n.t(
    'assignmentMessageProgressVerifierByOther',
    {
      ns: 'companyManagement',
    }
  ),
  unAssignmentMessageSelf: i18n.t('unAssignmentMessageSelf', {
    ns: 'companyManagement',
  }),
  undraftAllSubTasksNotificationMessage: i18n.t(
    'undraftAllSubTasksNotificationMessage',
    {
      ns: 'companyManagement',
    }
  ),
  undraftAllSubTasksNotificationMessageToUsers: i18n.t(
    'undraftAllSubTasksNotificationMessageToUsers',
    {
      ns: 'companyManagement',
    }
  ),
  taskIsReadyToPublishNotificationMessage: i18n.t(
    'taskIsReadyToPublishNotificationMessage',
    {
      ns: 'companyManagement',
    }
  ),
  subTasksAreReadyToPublishNotificationMessage: i18n.t(
    'subTasksAreReadyToPublishNotificationMessage',
    {
      ns: 'companyManagement',
    }
  ),
};
